// Базовый домен платформ без своего host'а (<slug>.<base>). На проде
// задаётся VITE_PLATFORM_BASE_DOMAIN при сборке; фолбэк — dev-safe.
export const PLATFORM_BASE_DOMAIN =
  import.meta.env.VITE_PLATFORM_BASE_DOMAIN ?? "ottkit.io";
